// extracted by mini-css-extract-plugin
module.exports = {"HostCompareDashboard":"HostCompareDashboard_XDra+"};